<app-banner [heading]="'PRINCIPAL\'S MESSAGE'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">


  <!-- ======= Features Section ======= -->
  <section id="features" class="features">
    <div class="container">

      <div class="row feature-item">
        <div class="col-lg-6 text-center">
          <img src="assets/img/about/principal2.jpeg" class="img-fluid" alt="">
        </div>
        <!-- <div class="col-lg-6  pt-5 pt-lg-0">
          <h4>From the Principal's Desk:</h4>
          <p>Welcome to our school website!</p>
          <p>Our school community continues to grow, and with it, our commitment to providing an exceptional educational
            experience remains unwavering.<br> At Tagore Global School, we focus on fostering a supportive and inclusive
            environment where every student has the opportunity to thrive. We have several new initiatives planned,
            including enhanced academic programs, extracurricular activities, and support services designed to help our
            students excel.</p>
          <p>At Tagore Global School, we believe in providing a holistic education that goes beyond the classroom. Our
            activities are designed to enhance learning, foster creativity, and build a sense of community among our
            students. From academic clubs and sports teams to arts and cultural programs, there is something for
            everyone.</p>
          <p>I encourage all parents and guardians to stay engaged and communicate with us regularly. Your involvement
            is crucial in supporting your child’s educational journey and helping us create a vibrant school community.
          </p>
        
         <div class="col-lg-12  pt-5 pt-lg-0"> -->
          <!-- <p>I encourage all students to explore these opportunities, get involved, and make the most of their time here
            at school.</p>
          <p>Thank you for your ongoing support and dedication. Together, we can make this year a successful and
            memorable one.
          </p>
          <p> -->
            <!-- Warm Regards --> 
          <!-- </p> -->
          <!-- <p>As our ideal Gurudev Ravindra Nath Tagore has said,</p>
          <p>
            “Where tireless striving stretches<br>
            Its arms towards perfection <br>
            Where the clear stream of reason<br>
            Has not lost its way<br>
            Into the dreary desert sand of dead habit“.........
          </p>
          <p>So is the vision and sincere effort of TGS family to raise our students to be able to
            make a mark for themselves in this competitive world.<br><br> God Bless !!
          </p> -->
<!-- 
          <p><strong>Shalini Malhotra</strong><br></p> -->
          <!-- <p>M.A Geo (hons), M.ed, 25 year experience</p> -->
          <!-- <br> -->
          <!-- <p><strong>Principal</strong><br> -->
            <!--
            M.A. (Eng.) , M.A ( Eco.), B.Ed. , D.Litt.<br>
            Ex.H.O.D. ( Eng, Eco)  St .Xavier’s Hr.Sec. School,Mohali (1995-2011)<br>
            Ex Principal , Saupin’s School, Panchkula (2011-2020)<br> -->
          <!-- </p>
        </div> -->


        <!-- new principal ................. -->
<div class="col-lg-6 pt-5 pt-lg-0">

  <h4>From the Principal's Desk:</h4>

  <p><strong>Warm greetings to everybody!!</strong></p>

  <p>
    Our school community keeps growing and strengthening necessarily along with our
    commitment to ensuring results-oriented educational endeavours and learning
    levels.
  </p>

  <p>
    At Tagore Global School, we focus on fostering a supportive and inclusive
    environment where every student gets the opportunity to learn, create, grow,
    and ultimately excel.
  </p>

  <p>
    We have multiple initiatives planned, including fully developed academic
    engagements, extracurricular involvements, and a cooperative service culture
    designed to help our students establish themselves beyond all comparisons.
  </p>

  <p>
    At Tagore Global School, we believe in creating an educational culture that is
    conducive to building a brighter future for our beloved students. Our curriculum
    and learning activities are carefully designed to promote learning, foster
    creativity, and develop a strong sense of fraternity and brotherhood among our
    students.
  </p>

  <p>
    To impart practical learning through extracurricular activities, we have
    Academic Clubs, Sports Clubs, Literary &amp; Cultural Clubs, Science Clubs,
    IT &amp; AI Clubs, Environmental &amp; Greenery Clubs, Wildlife Clubs, and
    many more.
  </p>

  <p>
    I invite and request all parents and guardians to stay connected and
    communicate with us regularly. Your active involvement and valuable
    participation have always been crucial in supporting your child's educational
    journey and helping us create a more friendly and well-equipped student
    community at Tagore Global School.
  </p>

  <p>
    I once again call upon all our dear students to explore every available
    opportunity, participate wholeheartedly, and begin their journey towards
    excellence under the guidance of Tagore Global School.
  </p>

  <p>
    Special thanks to you all for your unwavering support and dedication.
    Together, we will undoubtedly make this year—and many more to come—
    exceptionally successful, meaningful, and prosperous.
  </p>

  <p class="mt-4">
    <strong>Warm Regards,</strong>
  </p>

  <p>
    <strong>Hari Prakash Badoni</strong><br>
    <strong>Principal</strong>
  </p>

</div>
<!-- end -->
        <!-- </div> -->
      </div>
    </div>
  </section><!-- End Features Section -->





</main>